import { useEffect, useRef } from 'react';

export const useClickOutside = <T extends HTMLElement = HTMLElement>(
  callback: () => void
) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node;
      
      // Check if click is inside the ref element
      if (ref.current && !ref.current.contains(target)) {
        // Check if click is inside a Radix UI portal or helper element
        // Radix renders portals, focus guards, and other internal elements outside the normal DOM
        const isInsidePortal = (target as Element).closest('[data-radix-popper-content-wrapper]') ||
                              (target as Element).closest('[data-radix-portal]') ||
                              (target as Element).closest('[data-radix-focus-guard]') ||
                              (target as Element).closest('.radix-focus-guard') ||
                              (target as Element).closest('[role="dialog"]') ||
                              (target as Element).closest('[role="menu"]');
        
        // Only trigger callback if click is truly outside (not in portal or Radix helpers)
        if (!isInsidePortal) {
          callback();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [callback]);

  return ref;
};